<template>
  <div class="bg-card bg-white border-card-border md:px-6">
    <div class="w-full mt-2 md:mt-10 mb-6">
      <div>
        <h1
          slot="header"
          class="px-10 md:px-2 text-md sm:text-xl text-center font-semibold pb-1"
          v-if="this.$store.getters.preQualificationFailureReason === 'frozenCredit'"
        >
          It looks like your credit profile is frozen!
        </h1>

        <h1
          slot="header"
          class="px-10 md:px-2 text-md sm:text-xl text-center font-semibold pb-1"
          v-else-if="
            this.$store.getters.preQualificationFailureReason.includes('400') ||
            this.$store.getters.preQualificationFailureReason.includes('server')
          "
        >
          We’re sorry! We were unable to retrieve your credit profile.
        </h1>

        <h1
          slot="header"
          class="px-10 md:px-2 text-md sm:text-xl text-center font-semibold pb-1"
          v-else-if="this.preRejected"
        >
          We’re sorry! You did not pre-qualify for a loan.
        </h1>

        <h1
          slot="header"
          class="px-10 md:px-2 text-md sm:text-xl text-center font-semibold pb-1"
          v-else
        >
          We’re sorry! We are having issues determining pre-approvals at this time.
        </h1>

        <!-- <h3 slot="header" class="pb-3 border-b mb-4"></h3> -->
      </div>
      <div class="py-2">
        <div class="mb-6">
          <div
            class="flex-col text-center leading-none"
            v-if="this.$store.getters.preQualificationFailureReason === 'frozenCredit'"
          >
            <p class="text-xs text-center md:text-base px-3">
              Please unfreeze your credit and give us a call at (678) 685-8834 to retry
              pre-approval.
            </p>
          </div>
          <div
            class="flex-col leading-none"
            v-else-if="
              this.$store.getters.preQualificationFailureReason.includes('400') ||
              this.$store.getters.preQualificationFailureReason.includes('server')
            "
          >
            <p class="text-xs text-center md:text-base px-3">
              Please give us a call at (678) 685-8834 to review the information that you have
              provided.
            </p>
          </div>
          <div class="flex-col leading-none" v-else-if="this.preRejected">
            <p class="text-xs md:text-base text-center px-3">
              Based on the information you provided, we are unable to pre-approve you for a loan at
              this time.
            </p>
          </div>
          <div class="flex-col leading-none" v-else>
            <p class="text-xs md:text-base text-center px-3">
              Please give us a call at (678) 685-8834 to review the information that you have
              provided.
            </p>
          </div>
        </div>
        <div class="flex w-full justify-center content-center">
          <img
            alt="img"
            :src="require('@/assets/img/sketches/pre-approve-rejection.svg')"
            class="md:w-1/6 my-8"
          />
        </div>

        <div class="text-xs md:text-base text-center px-3">
          You may explore external sites to find a loan offer that works for you
        </div>
        <div class="flex w-full justify-center content-center my-4">
          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4">
            <base-button
              :class="`w-full ${start ? 'opacity-50' : ''}`"
              type="primary mr-auto"
              :disabled="start"
              aria-label="navigate next"
              id="prequal-reject-back-button"
              @click="updateTimestampAndRouteToQuinstreet()"
            >
              <p class="text-xs">Explore Other Loan Options</p>
            </base-button>
          </div>
        </div>
        <div class="flex w-full justify-center content-center mt-6">
          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4">
            <button
              class="btn base-button btn-primary mr-auto w-full bg-white"
              style="color: #69d393"
              type="primary mr-auto"
              :disabled="start"
              aria-label="navigate next"
              id="prequal-reject-back-button"
              @click="handleBack()"
            >
              <p class="text-xs">Return to Homepage</p>
            </button>
          </div>
        </div>

        <div class="flex w-full justify-center content-center mt-6">
          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 text-center">
            <button
              type="primary ml-auto"
              class="text-center btn base-button btn-primary mr-auto w-full bg-white"
              aria-label="navigate next"
              id="prequal-reject-start-app-button"
              @click="handleNext()"
              style="color: #69d393"
            >
              <p class="text-xs text-center">Continue to Loan Application</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'PrequalRej',
  data: function () {
    return {
      start: false
    }
  },
  computed: {
    preRejected() {
      if (this.$store.getters.preQualificationFailureReason.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    // Are we sure we want to emit denial here? Thought that this sends a rejection email
    this.$emit('denial', this.$store.getters.preQualificationFailureReason)
  },
  methods: {
    handleNext() {
      // window.scrollTo({ top: 0, behavior: 'smooth' })
      this.$emit('next')
    },
    handleBack() {
      // window.scrollTo({ top: 0, behavior: 'smooth' })
      this.$emit('back')
    },
    updateTimestampAndRouteToQuinstreet() {
      this.loading = true
      this.$apiClient
        .mutate({
          mutation: gql(
            `mutation { addQuinstreetTimestamp(username: "${this.$store.getters.username}") }`
          )
        })
        .then(({ data }) => {
          console.log(data)
        })
        .catch((e) => {
          console.log(e)
          console.log(`FE Error in updateQuinstreetTimestamp: ${e}`)
        })
        .finally(() => {
          this.loading = false
          const link = this.getExternalLoanLink()
          window.location.href = link
        })
    },
    getExternalLoanLink() {
      /**
       * This is a computed because in the future we might add
       * specific params to customize the loan links for users
       */
      return 'http://o1.qnsr.com/cgi/r?;n=203;c=1681890;s=32978;x=7936;f=202301031132330;u=j;z=TIMESTAMP;AFFID=prequalRejected'
    }
  }
}
</script>

<style scoped></style>
